import {writable} from 'svelte/store';

const REFERRAL_KEY = 'referral-v1';

export const referral$ = writable(readLocalReferral());

referral$.subscribe(({code, group}) => {
  if (!process.browser || !code || code === 'null') {
    return;
  }

  // 如果从 google 跳转，不写入referralCode到localStorage
  if (process.browser && '_URL_CLEANED' in window && window._URL_CLEANED) {
    return;
  }

  if (checkGroupEmptyString(group)) {
    group = null;
  }
  localStorage.setItem(REFERRAL_KEY, [code || '', group || '0'].join(','));
});

function readLocalReferral() {
  if (process.browser) {
    if ('_URL_CLEANED' in window && window._URL_CLEANED) {
      return {code: '', group: 0};
    }

    const referral = localStorage.getItem(REFERRAL_KEY);
    if (referral) {
      const [code, group] = referral.split(',');
      const inValid = checkGroupEmptyString(group);

      return {code: code === 'null' ? '' : code, group: inValid ? 0 : group};
    }
  }

  return {code: '', group: 0};
}

function checkGroupEmptyString(group) {
  return group?.toString()?.toUpperCase() === 'NAN' || group?.toString()?.toUpperCase() === 'UNDEFINED' || group?.toString()?.toUpperCase() === 'NULL';
}
